import "./EmployeeLimitedAccessPage.css";

function portalTitle(role) {
  const roleName = String(role || "employee").toLowerCase();
  return roleName === "manager" ? "Manager Worktivity Portal" : "Employee Worktivity Portal";
}

export default function EmployeeLimitedAccessPage({ role, onLogout, isDesktop }) {
  const title = portalTitle(role);
  const subtitle = isDesktop
    ? "You are signed in to the desktop role-based portal."
    : "You are signed in to the web role-based portal.";

  return (
    <main className="emp-limited-root">
      <article className="emp-limited-card">
        <div className="emp-limited-brand">
          <div className="emp-limited-logo">DIGITECHIO</div>
          <p className="emp-limited-tagline">Digital like never before</p>
        </div>

        <p className="emp-limited-status">{subtitle}</p>

        <div className="emp-limited-alert">
          <h2>{title}</h2>
          <p>This role currently has limited access screen.</p>
        </div>

        <div className="emp-limited-actions">
          <button type="button" className="emp-limited-logout" onClick={onLogout}>
            Logout
          </button>
        </div>
      </article>
    </main>
  );
}
